import { useState } from "react";
import { Link } from "react-router-dom";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import DefaultNavbar from "components/Navbars/DefaultNavbar";
import routes from "routes";

// Images
import bgImage from "assets/images/school.jpg";
import { FormControl, TextField } from "@mui/material";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "utils/firebase";
import { useError } from "hooks/ErrorContext";
import { useNavigate } from "react-router-dom";
import { useTheme } from '@mui/material/styles';
import { useAuth } from "hooks/AuthContext";

function SignInBasic() {
  const { showError } = useError();
  const navigate = useNavigate();
  const theme = useTheme();
  const {storeToken} = useAuth()

  const [formData, setFormData] = useState({
    password: "",
    email: "",
  });
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        formData.email,
        formData.password
      );
      const user = userCredential.user;

      if (user.emailVerified) {
        storeToken(user.accessToken)
        navigate('/home')
      } else {
        showError("Email not verified. Please verify your email before logging in.");
      }
    } catch (error) {
      showError("Please provide correct credenials");
    }
  };
  return (
    <>
      <MKBox
      position="absolute"
      top={0}
      left={0}
      zIndex={1}
      width="100%"
      minHeight="100vh"
      sx={{
        backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
          `${linearGradient(
            rgba(gradients.dark.main, 0.6),
            rgba(gradients.dark.state, 0.6)
          )}, url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <MKBox px={2} width="100%" height="100vh" mx="auto" position="relative" zIndex={2}>
        <Grid container spacing={3} justifyContent="center" alignItems="center" height="100%">
          <Grid item xs={11} sm={9} md={6} lg={4}>
            <Card
              sx={{
                borderRadius: "20px",
                boxShadow: "0px 8px 20px rgba(117, 44, 44, 0.1)",
                padding: "24px",
              }}
            >
              {/* Header */}
              <MKBox
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                textAlign="center"
                p={3}
                mb={3}
              >
                <MKTypography variant="h4" fontWeight="bold" color="white">
                  Welcome Back!
                </MKTypography>
                <MKTypography variant="body2" color="white" mt={1}>
                  Sign in to continue to your account
                </MKTypography>
              </MKBox>

              {/* Form */}
              <MKBox>
                <FormControl
                  component="form"
                  onSubmit={handleSubmit}
                  fullWidth
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 3,
                  }}
                >
                  <TextField
                    name="email"
                    type="email"
                    label="Email Address"
                    variant="outlined"
                    value={formData.email}
                    onChange={handleChange}
                    fullWidth
                    required
                    sx={{
                      "& .MuiInputBase-root": {
                        borderRadius: "10px",
                      },
                    }}
                  />
                  <TextField
                    name="password"
                    type="password"
                    label="Password"
                    variant="outlined"
                    value={formData.password}
                    onChange={handleChange}
                    fullWidth
                    required
                    sx={{
                      "& .MuiInputBase-root": {
                        borderRadius: "10px",
                      },
                    }}
                  />
                  <MKButton
                    type="submit"
                    variant="gradient"
                    color="info"
                    bgColor="info"
                    fullWidth
                    sx={{
                      borderRadius: "10px",
                      fontSize: "16px",
                      padding: "12px 0",
                    }}
                  >
                    Sign In
                  </MKButton>
                </FormControl>
              </MKBox>

              {/* Footer Links */}
              <MKBox mt={3} textAlign="center">
                <MKTypography variant="body2" color="textSecondary">
                  Don&apos;t have an account?{" "}
                  <MKTypography
                    component={Link}
                    to="/authentication/sign-up/cover"
                    variant="body2"
                    color="info"
                    fontWeight="bold"
                    textGradient
                  >
                    Sign Up
                  </MKTypography>
                </MKTypography>
                <MKTypography variant="body2" color="textSecondary" mt={1}>
                  Or{" "}
                  <MKTypography
                    component={Link}
                    to="/authentication/otp"
                    variant="body2"
                    color="info"
                    fontWeight="bold"
                    textGradient
                  >
                    Sign in via OTP
                  </MKTypography>
                </MKTypography>
              </MKBox>
            </Card>
          </Grid>
        </Grid>
      </MKBox>
    </MKBox>
    </>
  );
}

export default SignInBasic;
